import React from "react";

import { Row, Col, Box, CampoEstatico, TipoCampoEstatico, Botao, Alerta, TipoAlerta } from "@intechprev/componentes-web";

import { HomeCard } from "./HomeCard";
import { PlanoVinculadoService, FichaSalarioContribuicaoService, FichaContribPrevidencialService, DadosPessoaisService } from "../../services";
import { FichaSalarioContribuicaoEntidade, PlanoVinculadoEntidade } from "../../entidades";
import { Link } from "react-router-dom";
import Quotas from "./Quotas";
import { Dependentes } from "./Dependentes";
import { Contato } from "./Contato";

interface Props {
  page: any;
  plano: PlanoVinculadoEntidade;
}

interface State {
  plano: any;
  salario: any;
  ultimaContribuicao: any;
  saldos: any;
  quotas: any[];
  dataAposentadoria: any;
  perfil: string;
  erro: string;
}

export class HomeAtivo extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      plano: new PlanoVinculadoEntidade(),
      salario: new FichaSalarioContribuicaoEntidade(),
      ultimaContribuicao: {},
      saldos: {},
      quotas: [],
      dataAposentadoria: "",
      perfil: "",
      erro: ""
    }
  }

  componentDidMount = async () => {
    await this.props.page.current.loading(true);
    try {
      await this.carregarDados(this.props.plano);
    }
    catch (e) {
      this.setState({
        erro: e.response ? e.response.data : e
      });
    }
    finally {
      await this.props.page.current.loading(false);
    }
  }

  carregarDados = async (plano: PlanoVinculadoEntidade) => {
    var salario = await FichaSalarioContribuicaoService.BuscarPorPlano(plano.SQ_PLANO_PREVIDENCIAL);
    var ultimaContribuicao = await FichaContribPrevidencialService.BuscarPorPlano(plano.SQ_PLANO_PREVIDENCIAL);
    var saldos = await FichaContribPrevidencialService.BuscarSaldos(plano.SQ_PLANO_PREVIDENCIAL);
    var dataAposentadoria = await DadosPessoaisService.BuscarDataAposentadoria();
    var quotas = await FichaContribPrevidencialService.BuscarQuotas(plano.SQ_PLANO_PREVIDENCIAL);
    var perfil = await PlanoVinculadoService.BuscarPerfilInvestimento(plano.SQ_PLANO_PREVIDENCIAL);

    this.setState({ plano, salario, ultimaContribuicao, saldos, dataAposentadoria, quotas, perfil });
  }

  render() {
    return (
      <div>
        {this.state.erro && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />}

        {this.state.saldos.lista && this.state.saldos.lista.length > 0 &&
          <div>
            <Row>
              <Col>
                <HomeCard titulo={"Plano"}>
                  {this.props.plano.DS_PLANO_PREVIDENCIAL}
                  <br />
                  <small>
                    <span style={{ "fontWeight": "normal" }}>
                      {`CNPB: ${this.props.plano.NR_CODIGO_CNPB}`}
                    </span>
                  </small>
                </HomeCard>
              </Col>
              <Col tamanho={"lg-3"}>
                <HomeCard titulo={"Situação"}>
                  {this.props.plano.DS_SIT_PLANO}
                </HomeCard>
              </Col>
              <Col>
                {this.state.salario &&
                  <HomeCard titulo={"Seu Último Salário de Contribuição"} label={this.state.salario.DT_REFERENCIA}>
                    <CampoEstatico valor={this.state.salario.VL_BASE_FUNDACAO} tipo={TipoCampoEstatico.dinheiro} />
                  </HomeCard>
                }
                {!this.state.salario &&
                  <HomeCard titulo={"Seu Último Salário de Contribuição"}>
                    <CampoEstatico valor={'-'} tipo={TipoCampoEstatico.texto} />
                  </HomeCard>
                }
              </Col>
              {this.state.perfil && <Col>
                <HomeCard titulo={"Perfil de Investimento"}>
                  {this.state.perfil}
                </HomeCard>
              </Col>}
            </Row>

            {/* <Row className={"mt-4"}>
                            <Col>
                                <Box titulo={"Sua Última Contribuição"} label={this.state.salario.DT_REFERENCIA}>

                                    <table className={"table table-striped table-sm"}>
                                        <tbody>
                                            {this.state.ultimaContribuicao.map((contrib, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{contrib.DS_TIPO_FUNDO} - {contrib.DS_TIPO_COBRANCA}</td>
                                                        <td className={"text-right"}>
                                                            <CampoEstatico valor={contrib.VL_CONTRIBUICAO} tipo={TipoCampoEstatico.dinheiro} />
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>

                                </Box>
                            </Col>
                        </Row> */}

            <Dependentes SqPlano={this.state.plano.SQ_PLANO_PREVIDENCIAL} />

            {this.state.saldos.lista.length > 0 &&
              <Row>
                <Col>
                  <Box titulo={"Saldos Acumulados"}>

                    {this.state.saldos.lista.length > 2 &&
                      <h3 className={"text-center text-primary mb-5"}>
                        Parabéns! Você já acumulou <b className={"text-secondary"}><CampoEstatico valor={this.state.saldos.lista[2].VL_ATUALIZADO} tipo={TipoCampoEstatico.dinheiro} /></b>
                      </h3>
                    }

                    {this.state.saldos.lista.length <= 2 &&
                      <h3 className={"text-center text-primary mb-5"}>
                        Parabéns! Você já acumulou <b className={"text-secondary"}><CampoEstatico valor={this.state.saldos.lista[this.state.saldos.lista.length - 1].VL_ATUALIZADO} tipo={TipoCampoEstatico.dinheiro} /></b>
                      </h3>
                    }

                    <Row>
                      <Col>
                        <table className={"table table-striped table-sm"}>
                          <thead>
                            <tr>
                              <th></th>
                              <th className={"text-right"}>Saldo Atualizado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.saldos.lista.map((saldo: any, index: number) => {
                              // Define o tipo de linha (td ou th) baseado no index. Se for o ultimo, será o total, e será th
                              var Td = (props: any) => <td className={props.className}>{props.children}</td>;

                              if (index == this.state.saldos.length - 1)
                                Td = (props: any) => <th className={props.className}>{props.children}</th>;

                              return (
                                <tr key={index}>
                                  <Td>{saldo.DS_TIPO_FUNDO}</Td>
                                  <Td className={"text-right"}>
                                    <CampoEstatico valor={saldo.VL_ATUALIZADO} tipo={TipoCampoEstatico.dinheiro} />
                                  </Td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </Col>
                      <Col>
                        <Quotas quotas={this.state.quotas} />
                      </Col>
                    </Row>

                  </Box>
                </Col>
              </Row>
            }

            <Row>
              <Col tamanho={"sm-12"} className={"col-md-6"}>
                <Box titulo={"Simulador de Resgate"}>
                  <h5>Simule o valor atualizado do seu resgate de contribuições</h5>
                  {/* <Link className="btn btn-primary btn-block mt-3" id="esqueciSenha" to="/resgate">Ir para Simulador de Resgate</Link> */}
                  <Botao
                    block
                    className={'mt-3'}
                    onClick={() => window.alert('Em construção...')}
                    titulo={"Ir para Simulador de Resgate"}
                  />
                </Box>
              </Col>

              <Col tamanho={"sm-12"} className={"col-md-6"}>
                <Box titulo={"Simulador de Portabilidade"}>
                  <h5>Simule o valor atualizado do seu saldo para portabilidade</h5>
                  {/* <Link className="btn btn-primary btn-block mt-3" id="esqueciSenha" to="/portabilidade">Ir para Simulador de Portabilidade</Link> */}
                  <Botao
                    block
                    className={'mt-3'}
                    onClick={() => window.alert('Em construção...')}
                    titulo={"Ir para Simulador de Portabilidade"}
                  />
                </Box>
              </Col>
            </Row>

            {/* {this.state.dataAposentadoria &&
                            <Row>
                                <Col>
                                    <Box>
                                        <h3 className={"text-center text-primary mb-5"}>
                                            Faltam {this.state.dataAposentadoria.Anos} anos, {this.state.dataAposentadoria.Meses} meses e {this.state.dataAposentadoria.Dias} dias para sua aposentadoria programada (aos 62 anos)
                                        </h3>
                                    </Box>
                                </Col>
                            </Row>
                        } */}
          </div>
        }

        <Contato />
      </div>
    );
  }
}